import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../../components/Models/admin-modal-theme";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
import {
  createHomeworkRequest,
  editHomeworkRequest,
} from "../../../../modules/admin-modules/homework/Actions";
import { closeAddHomeworkModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllVideosRequest } from "../../../../modules/admin-modules/videos/Actions";
const AddHomework = ({ isAdd, data, setSelectedData }) => {
  const openVideo = useSelector((state) => state.model.isOpen22);
  const isLoading = useSelector((state) => state.videos.isLoading);

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? { ...data, title: data?.title } : {},
    shouldUnregister: true,
  });

  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const videos = useSelector((state) => state.videos.videos);

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const videosOptions = videos?.map((data) => {
    return { value: data.id, label: data.title };
  });

  useEffect(() => {
    if (openVideo) {
      if (chapters.length == 0) dispatch(getAllChaptersRequest());
      if (groups.length == 0) dispatch(getAllGroupsRequest());
      if (videos.length == 0) dispatch(getAllVideosRequest());
    }
  }, [openVideo]);

  const selectStyles = useMemo(
    () => adminSelectStyles({ hasError: !!errors?.chapter_id?.message }),
    [errors?.chapter_id?.message]
  );

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color={brandPalette.primary}
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add Homework" : "Edit Homework"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="rgba(69, 11, 17, 0.6)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Link homework to chapter, groups, and optional session video
      </Text>
    </Box>
  );
  const onSubmit = async (values) => {
    const action = (data) => {
      dispatch(closeAddHomeworkModel());
      reset();
      setSelectedData(() => { });
    };
    if (isAdd) {
      let formData = await new FormData();
      for (let key in values) {
        if (key == "groups") {
          values[key]?.map((val, idx) =>
            formData.append(`groups[${idx}]`, val)
          );
        } else {
          formData.append(key, values[key]);
        }
      }
      await dispatch(createHomeworkRequest(formData, action));
    } else {
      let formData = await new FormData();
      formData.append("_method", "PUT");
      const totel = { ...data, ...values };
      for (let key in totel) {
        if (key == "groups") {
          totel[key]?.map((val, idx) =>
            formData.append(`groups[${idx}]`, val?.id ? val?.id : val)
          );
        } else {
          formData.append(key, totel[key]);
        }
      }
      dispatch(
        editHomeworkRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeAddHomeworkModel());
    setSelectedData(() => { });
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openVideo}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="4xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacingX={8}
            spacingY={6}
            alignItems="start"
          >
            <MainInput
              label="Homework title"
              defaultValues={data?.name}
              error={errors?.name?.message}
              placeholder="Title shown to students"
              register={register}
              name="name"
            />
            <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
              <FormLabel
                m={0}
                fontSize="14px"
                fontWeight="700"
                color={brandPalette.primary}
                textAlign="left"
              >
                Notes / instructions
              </FormLabel>
              <Textarea
                mt={2}
                bg={brandPalette.cream}
                borderRadius="12px"
                border="1px solid"
                borderColor={brandPalette.stone}
                defaultValue={data?.homework}
                placeholder="Instructions or notes for this homework"
                {...register("homework", { required: "This field is required" })}
                name="homework"
              />
            </Box>
            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Chapter
                </FormLabel>
                <Select
                  options={chaptersOptions}
                  defaultValue={{
                    label: data?.chapter?.name,
                    value: data?.chapter?.id,
                  }}
                  onChange={(d) => setValue("chapter_id", d.value)}
                  styles={selectStyles}
                  placeholder="Select chapter"
                />
              </VStack>
            </FormControl>
            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Groups
                </FormLabel>
                <Select
                  options={groupsOptions}
                  isMulti
                  defaultValue={data?.groups?.map((val) => ({
                    label: val?.name,
                    value: val?.id,
                  }))}
                  onChange={(d) => {
                    const selectedGroups = d.map((val) => val.value);
                    setValue("groups", selectedGroups);
                  }}
                  styles={selectStyles}
                  placeholder="Select groups"
                />
              </VStack>
            </FormControl>
            <Box>
              <FormLabel
                m={0}
                mb={2}
                fontSize="14px"
                fontWeight="700"
                color={brandPalette.primary}
              >
                Visibility
              </FormLabel>
              <Stack direction="row" flexWrap="wrap" gap={4} role="group">
                <label>
                  <input
                    {...register("enable", { required: true })}
                    type="radio"
                    value="0"
                    defaultChecked={data?.enable == 0 ? true : false}
                  />{" "}
                  Hidden
                </label>
                <label>
                  <input
                    {...register("enable", { required: true })}
                    type="radio"
                    value="1"
                    defaultChecked={data?.enable == 1 ? true : false}
                  />{" "}
                  Published
                </label>
              </Stack>
            </Box>
            <Box>
              <FormLabel
                m={0}
                mb={2}
                fontSize="14px"
                fontWeight="700"
                color={brandPalette.primary}
              >
                Active
              </FormLabel>
              <Stack direction="row" flexWrap="wrap" gap={4} role="group">
                <label>
                  <input
                    {...register("active", { required: true })}
                    type="radio"
                    value="0"
                    defaultChecked={data?.active === 0 ? true : false}
                  />{" "}
                  Inactive
                </label>
                <label>
                  <input
                    {...register("active", { required: true })}
                    type="radio"
                    value="1"
                    defaultChecked={data?.active === 1 ? true : false}
                  />{" "}
                  Active
                </label>
              </Stack>
            </Box>
            <FormControl gridColumn={{ base: "auto", md: "1 / -1" }}>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color={brandPalette.primary}
                  textAlign="left"
                >
                  Related session video (optional)
                </FormLabel>
                <Select
                  options={videosOptions}
                  defaultValue={{
                    label: data?.video?.title,
                    value: data?.video?.id,
                  }}
                  onChange={(d) => setValue("video_id", d.value)}
                  styles={selectStyles}
                  placeholder="Select video"
                />
              </VStack>
            </FormControl>
          </SimpleGrid>
          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color={brandPalette.accentDark}
              fontWeight="800"
              _hover={{ textDecoration: "underline" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddHomework;
